import * as React from 'react';
import classnames from 'classnames';
import { translate } from 'components/translate-hoc';
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';

// components
import Button from 'components/button';

// types
import { IGameInstallerProps } from './game-installer.types';

// constants
import {
    DOWNLOAD_UPLAY_ANALYTICS_ATTRIBUTES,
    LAUNCH_UPLAY_ANALYTICS_ATTRIBUTES,
    BRANDED_INSTALLER_ANALYTICS_ATTRIBUTES,
    TEXT_KEYS,
    URLS
} from './game-installer.constants';

import './game-installer.styles.less';

export class GameInstaller extends React.Component<IGameInstallerProps, {}> {
    public handleDownloadUplay = () => {
        AnalyticsService.sendClickEvent(DOWNLOAD_UPLAY_ANALYTICS_ATTRIBUTES);
        window.open(URLS.DOWNLOAD_UPLAY, '_top');
    };

    public handlePreloadGame = () => {
        const { gameId } = this.props;
        AnalyticsService.sendClickEvent(LAUNCH_UPLAY_ANALYTICS_ATTRIBUTES);
        window.open(URLS.PRELOAD_GAME(gameId), '_top');
    };

    public handleDownloadBrandedInstaller = () => {
        AnalyticsService.sendClickEvent(BRANDED_INSTALLER_ANALYTICS_ATTRIBUTES);
        window.open(this.props.brandedInstallerUrl, '_top');
    };

    public renderNonBrandedInstaller = () => {
        const translateKey = this.props.dangerouslyTranslateWithHTML;
        const downloadUplayBtnText = translateKey(TEXT_KEYS.CTA_DOWNLOAD_UPLAY);
        const preloadGameBtnText = translateKey(TEXT_KEYS.CTA_PRELOAD_GAME);

        return <>
            <Button onClick={this.handlePreloadGame}>
                {preloadGameBtnText}
            </Button>
            <Button type="secondary" onClick={this.handleDownloadUplay}>
                {downloadUplayBtnText}
            </Button>
        </>;
    };

    public renderBrandedInstaller = () => {
        const translateKey = this.props.dangerouslyTranslateWithHTML;
        const title = translateKey(TEXT_KEYS.CTA_DOWNLOAD_BRANDED_INSTALLER);

        return <Button onClick={this.handleDownloadBrandedInstaller}>{title}</Button>;
    };

    public render(): JSX.Element {
        const { hasBrandedInstaller, direction } = this.props;

        return <div className="sitegen-game-installer">
            <div className={classnames('sitegen-game-installer__buttons-container', {
                'flex-direction-row': direction === 'row'
            })}>
                {
                    hasBrandedInstaller
                        ? this.renderBrandedInstaller()
                        : this.renderNonBrandedInstaller()
                }
            </div>
        </div>;
    }
}

export default translate()(GameInstaller);
